import { Link, useParams } from 'react-router-dom';
import { useSession, useContent } from '../hooks/useSession';
import { findTrack, lessonKey, trackMinutes } from '../lib/curriculum';
import { Icon, Tick } from '../components/Icon';

export function TrackPage() {
  const { trackId = '' } = useParams();
  const content = useContent();
  const { progress } = useSession();

  const track = findTrack(content, trackId);
  if (!track) {
    return (
      <div className="vu-wrap">
        <h1 className="vu-h2">Track not found</h1>
        <p className="vu-muted">
          It may have been renamed. <Link to="/" style={{ color: 'var(--text-link)' }}>Back to the dashboard</Link>.
        </p>
      </div>
    );
  }

  return (
    <div className="vu-wrap">
      <Link to="/" className="vu-subtle" style={{ display: 'inline-block', marginBottom: 'var(--space-5)' }}>
        ← All tracks
      </Link>

      <div style={{ display: 'flex', gap: 'var(--space-5)', alignItems: 'flex-start' }}>
        <span className="vu-icon-tile" style={{ background: track.tint, width: 56, height: 56, flexBasis: 56, borderRadius: 16 }}>
          <Icon path={track.icon} size={26} color="var(--brand-primary)" />
        </span>
        <div>
          <h1 className="vu-h1" style={{ fontSize: 'var(--fs-h1)' }}>{track.name}</h1>
          <p className="vu-lede" style={{ fontSize: 'var(--fs-lg)', marginTop: 6 }}>{track.blurb}</p>
        </div>
      </div>

      <div className="vu-subtle" style={{ margin: 'var(--space-6) 0 var(--space-4)' }}>
        {track.lessons.length} lessons · {trackMinutes(track)} min in total
      </div>

      {track.lessons.map((lesson, i) => {
        const done = !!progress.done[lessonKey(track.id, lesson.id)];
        return (
          <Link
            key={lesson.id}
            to={`/track/${track.id}/${lesson.id}`}
            className="vu-card vu-card-hover"
            style={{ display: 'block', marginBottom: 'var(--space-3)', padding: 'var(--space-5) var(--space-6)' }}
          >
            <div className="vu-row" style={{ alignItems: 'flex-start' }}>
              <span className="vu-num" data-done={done}>
                {done ? <Tick size={14} /> : i + 1}
              </span>
              <span style={{ flex: 1, minWidth: 0 }}>
                <span className="vu-h3" style={{ fontSize: 'var(--fs-lg)', display: 'block' }}>{lesson.title}</span>
                <span className="vu-muted" style={{ fontSize: 'var(--fs-sm)', display: 'block', marginTop: 4 }}>
                  {lesson.summary}
                </span>
              </span>
              <span className="vu-subtle" style={{ whiteSpace: 'nowrap' }}>{lesson.mins} min</span>
            </div>
          </Link>
        );
      })}
    </div>
  );
}
